import React, { useRef, useState } from "react";
import {
  Button,
  Checkbox,
  Container,
  Form,
  Input,
  List,
  ListItem,
  DeleteButton,
  Title,
  TodoText,
  fadeIn,
  fadeOut,
} from "./styled";
import useOnClickOutside from "../../_hooks/useOnClickOutside";

const Todos = () => {
  // Retrieve stored todos from local storage, or use default value if not found
  const storedTodos = JSON.parse(localStorage.getItem("todos")) || [
    { id: 1, text: "Your todo will appear here", completed: false },
  ];
  const [todos, setTodos] = useState(storedTodos);
  const [newTodo, setNewTodo] = useState("");
  const [modalShown, toggleModal] = React.useState(false);

  // Create a ref that we add to the element for which we want to detect outside clicks
  const ref = useRef();
  // State for our modal
  const [isModalOpen, setModalOpen] = useState(false);
  // Call hook passing in the ref and a function to call on outside click
  useOnClickOutside(ref, () => setModalOpen(false));

  function handleChange(e) {
    setNewTodo(e.target.value);
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (newTodo.trim() === "") return;
    const updatedTodos = [
      ...todos,
      {
        id: Date.now(),
        text: newTodo,
        completed: false,
      },
    ];
    setTodos(updatedTodos);
    setNewTodo("");
    // Save todos to local storage
    localStorage.setItem("todos", JSON.stringify(updatedTodos));
  }

  function toggleTodo(id) {
    const updatedTodos = todos.map((todo) => {
      if (todo.id === id) {
        return {
          ...todo,
          completed: !todo.completed,
        };
      }
      return todo;
    });
    setTodos(updatedTodos);
    // Save todos to local storage
    localStorage.setItem("todos", JSON.stringify(updatedTodos));
  }

  function deleteTodo(id) {
    const updatedTodos = todos.filter((todo) => todo.id !== id);
    setTodos(updatedTodos);
    // Save todos to local storage
    localStorage.setItem("todos", JSON.stringify(updatedTodos));
  }

  return (
    <div>
      {isModalOpen ? (
        <Container ref={ref} animation={isModalOpen ? fadeIn : fadeOut}>
          <Title>Todo List</Title>
          <Form onSubmit={handleSubmit}>
            <Input
              type="text"
              placeholder="Add a new to-do"
              value={newTodo}
              onChange={handleChange}
            />
            <Button type="submit">Add</Button>
          </Form>
          <List>
            {todos.map((todo) => (
              <ListItem key={todo.id}>
                <Checkbox
                  type="checkbox"
                  checked={todo.completed}
                  onChange={() => toggleTodo(todo.id)}
                />
                <TodoText completed={todo.completed}>{todo.text}</TodoText>
                <DeleteButton onClick={() => deleteTodo(todo.id)}>
                  X
                </DeleteButton>
              </ListItem>
            ))}
          </List>
        </Container>
      ) : (
        <Button onClick={() => setModalOpen(true)}>Todo</Button>
      )}
    </div>
  );
};

export default Todos;
//
